module.exports = __webpack_public_path__ + "static/media/filter_set.49b05cbb.png";